import React from "react";
import { Form } from "rsuite";

const BankDetails = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Name maintained at Bank</Form.ControlLabel>
        <Form.Control name="NameatBank" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Bank Name</Form.ControlLabel>
        <Form.Control name="Bank Name" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Branch Name</Form.ControlLabel>
        <Form.Control name="Branch Name" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Account Type</Form.ControlLabel>
        <Form.Control name="Account Type" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Account No.</Form.ControlLabel>
        <Form.Control name="Account No." />
      </Form.Group>
    </div>
  );
};

export default BankDetails;
